import VideoModal from '../components/common/modal/video-modal'
import Grid from '../components/grid'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { Asset } from '../v2/components/Asset'
import { Page, Asset as AssetType } from '@telesoft/types/payload-types'
import dynamic from 'next/dynamic'
import React, { Fragment, ReactElement } from 'react'
import { BsChevronRight } from 'react-icons/bs'

const ReactPlayer = dynamic(() => import('react-player'), { ssr: false })

export type BlockProps = Extract<Page['blocks'][0], { blockType: 'video-highlight' }>

export default function VideoHighlight(block: BlockProps): ReactElement {
  const [showModal, setShowModal] = React.useState(false)
  const { title, subTitle, url = 'https://www.youtube.com/embed/sjkiw7OYbVY' } = block
  const image = block?.options?.image as AssetType
  const variant = block?.options?.variant ?? 'popup'

  return (
    <Fragment>
      {variant === 'popup' && (
        <VideoModal
          showModal={showModal}
          setShowModal={setShowModal}
          title={title || 'TDAC at scale'}
          url={url}
        />
      )}

      <Container>
        <Grid className="gap-0 md:gap-8">
          <div className="col-span-full md:col-span-4 lg:col-span-6">
            <Text className="mt-2" variant="subHeading">
              {title}
            </Text>
          </div>

          <Text className="col-span-full  md:col-span-4 lg:col-span-6 mt-2" variant="heading">
            {subTitle}
          </Text>

          {variant === 'inline' && (
            <div className="col-span-full relative pt-[56.25%]">
              <ReactPlayer
                title={title}
                url={url}
                className="absolute inset-0"
                width={'100%'}
                height={'100%'}
              />
            </div>
          )}

          {variant === 'popup' && (
            <button
              type="button"
              onClick={() => setShowModal(true)}
              className="group relative col-span-full mt-8 md:mt-0 overflow-hidden"
            >
              <Asset
                resource={image as AssetType}
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-1000"
                fill
              />

              <div className="absolute group-hover:opacity-80 flex justify-end items-center bottom-5 left-4">
                <div
                  className={`w-14 h-14 flex justify-center group-hover:border-telesoft items-center bg-accent-1 col-span-1 col-start-9 group-hover:bg-telesoft text-heading z-20 transition duration-300`}
                >
                  <BsChevronRight className="" />
                </div>
                <div className="w-20 h-[1px] bg-white mx-5" />

                <Text
                  variant="headingLight"
                  className="whitespace-nowrap font-medium text-white"
                >{`Play Video`}</Text>
              </div>
            </button>
          )}
        </Grid>
      </Container>
    </Fragment>
  )
}
